import axios from 'axios';
import { ENV_CONFIG } from '../../../config/config';

export const clinicasApi = (tokenAutorizacion:any) => axios.create({
    baseURL: `${ENV_CONFIG.REPORTANTES_URL_CLINICAS}`,
    headers: {
        'Authorization': 'Bearer ' + tokenAutorizacion,
        'Content-Type': 'application/json'
    }
});